<template>
    <div class="container-fluid mt-3">
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs6 md3 justify-center layout>
            <v-chip :color="color" text-color="white">
              <v-avatar class="green darken-4">{{currencyUpperCase}} </v-avatar>
              <span class="bal" v-cloak>{{parseInt(p1.btcBalance*1000000)/1000000}}</span>
            </v-chip>
          </v-flex>
          <v-flex xs6 md3 justify-center layout>
            <v-chip :color="color2" text-color="white">
              <v-avatar class="green darken-4">{{secondUpperCase}} </v-avatar>
              <span class="bal">{{parseInt(p2.btcBalance*10)/10}} </span>
            </v-chip>
          </v-flex>
        </v-layout>
        
      </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    assset: {
      type: String,
    },
    currency:{
      type:String
    },
    second:{
      type:String
    },
    color:{
      type:String
    },
    color2:{
      type:String
    }

  },
  data() {
    return {
      hm: false
    }
  },
mounted () {
  this.init()
    
},
computed: {
 currencyUpperCase() {
    return this.currency.toUpperCase()
  },
  secondUpperCase() {
    return this.second.toUpperCase()
  },
  ...mapState({
      p1(state,getters) {
        return getters["authfb/"+this.currency]
    },
    p2(state,getters) {
        return getters["authfb/"+this.second]
    },
    }),
},
methods: {
  ... mapActions("authfb", ["init"])
},
}
</script>

<style scoped>
[v-cloak] { display: none !important; }

.bal {
  font-size: 1.5em;
  color: black;

}

</style>
